import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { connect, useDispatch, useSelector } from 'react-redux';
import BeatLoader from 'react-spinners/BeatLoader';
import { LoadingStyle } from '../../../styles';
import SearchInput from '../../shared/SearchInput';
import { BPagination } from '../../shared/Pagination';
import React, { useEffect, useMemo, useState } from 'react';
import { ApplicationGrid } from './application.grid';
import { fetchApplicationData, updateApplicationData } from '../../../actions/admin/application.action';
import { Card, Col, Container, Row } from 'react-bootstrap';
import Notifications from 'react-notification-system-redux';

const Application = ({ loading, applicationData, ...props }) => {
    const [filteredData, setFilteredData] = useState([]);

    const arr = useMemo(() => applicationData, [applicationData]);

    const error = useSelector((state) => state.application.error);

    const dispatch = useDispatch();
    useEffect(() => {
        console.log('request data');
        if (props.authState?.isAuthenticated) {
            props.fetchApplicationData(props.authState.accessToken.accessToken);
        }
    }, []);

    useEffect(() => {
        setFilteredData(arr);
    }, [arr]);

    useEffect(() => {
        if (!error) return;
        dispatch(Notifications.error({
            title: 'Unable to save changes',
            message: error,
            position: 'tr',
            autoDismiss: 10,
        }));
    }, [error]);

    const handleDeleteItem = (item) => {

    };

    const handleUpdate = (item) => {
        if (props.authState?.isAuthenticated) {
            props.updateApplicationData({ application: item, jwt: props.authState.accessToken.accessToken });
        }
    };

    const handleAddItemModal = () => {
    };

    const handleSearch = (searchTerm) => {
        const result = filterData({ searchTerm, data: applicationData });
        setFilteredData(result);
    };

    const filterData = ({ data, searchTerm } = { data: [], searchTerm: '' }) => {
        if (!searchTerm) return data;

        return data.filter((item) => Object.values(item).some((value) => value && typeof value === typeof searchTerm && value.toLowerCase().includes(searchTerm.toLowerCase())));
    };

    return <Container fluid className="main-panel main-panel-analytics">
        <div className="container">
            <div className="page-inner">
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title></Card.Title>
                                <Card.Subtitle></Card.Subtitle>
                            </Card.Body>
                            <Card.Body>
                                {loading ? (<BeatLoader css={LoadingStyle} size={12} color={'#1C23BA'} loading={true}
                                                        speedMultiplier={0.8} />) : <span />}
                                <SearchInput onSearch={handleSearch} />

                                <ApplicationGrid items={filteredData || []} onUpdate={handleUpdate} />
                            </Card.Body>
                        </Card>

                    </Col>
                </Row>
            </div>
        </div>
    </Container>;
};


const mapStateToProps = (state) => ({
    applicationData: state.application.applicationData, loading: state.application.loading,
});


export default compose(withRouter, withOktaAuth, connect(mapStateToProps, {
    fetchApplicationData, updateApplicationData,
}))(Application);